export default {
  path: 'chargingStandard',
  name: 'chargingStandard',
  component: () => import('@/pages/inquiries/chargingStandard'),
  meta: { title: '授权信息' }

}
